import React from 'react';
import 'src/components/2.2.0/loading-square/style.css';

export default function LoadingSquare() {
  return (
    <div className="loader">
      <span> </span>
      <span> </span>
      <span> </span>
      <span> </span>
    </div>
  );
}
